<template>
  <div>
    <b-row>
      <b-col md="12">
        <component-header
          title="Authentication Security Setting"
          :hasSearch="false"
          :hasReload="false"
          :hasCreate="false"
          :hasback="false"
        />
      </b-col>
      <b-col>
        <b-card>
          <b-row>
            <b-col>
              <b-tabs v-model="tabIndex">
                <b-tab
                  :title="type.toLocaleUpperCase()"
                  v-for="(type, ind) in allTypes"
                  :key="ind"
                >
                  <b-row>
                    <b-col md="12">
                      <h5>Select the login type</h5>
                    </b-col>
                    <b-col md="12">
                      <b-form-checkbox
                        id="checkbox-1"
                        v-model="otpBased"
                        name="checkbox-1"
                      >
                        <p class="ml-2 small-text">OTP Based</p>
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2" v-if="otpBased">
                    <b-col md="12">
                      <h5>Select send through</h5>
                    </b-col>
                    <b-col md="12">
                      <b-form-radio-group
                        id="radio-group-2"
                        @change="changeOtpSendThrough"
                        name="send-through-group"
                      >
                        <b-form-radio value="viaSms" class="ml-2 small-text"
                          >OTP via SMS</b-form-radio
                        >
                        <b-form-radio value="viaEmail" class="ml-2 small-text"
                          >OTP via Email</b-form-radio
                        >
                        <b-form-radio value="both" class="ml-2 small-text"
                          >Both</b-form-radio
                        >
                      </b-form-radio-group>
                    </b-col>
                    <b-col md="12">
                      <h5>Select OTP login & sign up style</h5>
                    </b-col>
                    <b-col md="12">
                      <b-form-radio-group
                        id="radio-group-3"
                        @change="changeLoginStyle"
                        name="otp-login-style-group"
                      >
                        <b-form-radio value="common" class="ml-2 small-text"
                          >Common</b-form-radio
                        >
                        <b-form-radio value="separate" class="ml-2 small-text"
                          >Separate</b-form-radio
                        >
                      </b-form-radio-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <b-form-checkbox
                        id="checkbox-2"
                        v-model="passwordBased"
                        name="checkbox-2"
                      >
                        <p class="ml-2 small-text">Password Based</p>
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                  <b-row class="password-based">
                    <b-col
                      md="12"
                      class="flex align-items-center justify-content-between"
                    >
                      <h4>Enable 2- Factor Authentication</h4>
                      <c-switch
                        class="mx-1"
                        color="primary"
                        v-model="enableTwoFactor"
                        label
                        variant="pill"
                        data-on="|"
                        data-off="|"
                      />
                    </b-col>
                    <b-col class="factor" md="12" v-if="enableTwoFactor">
                      <b-row>
                        <b-col md="12">
                          <div
                            class="flex align-items-center justify-content-between"
                          >
                            <h4>OTP Based Verification</h4>
                            <c-switch
                              class="mx-1"
                              color="primary"
                              v-model="enableTwoFactorOtp"
                              label
                              variant="pill"
                              data-on="|"
                              data-off="|"
                            />
                          </div>
                        </b-col>
                        <b-col md="12" v-if="enableTwoFactorOtp">
                          <b-form-radio-group
                            id="radio-group-3"
                            @change="changeOtpSendThrough2"
                            name="radio-sub-component"
                          >
                            <b-form-radio value="twoFactorOtpViaSms"
                              ><p class="ml-2 small-text">OTP via SMS</p>
                            </b-form-radio>
                            <b-form-radio value="twoFactorOtpViaEmail"
                              ><p class="ml-2 small-text">OTP via Email</p>
                            </b-form-radio>
                          </b-form-radio-group>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col class="factor mt-2" md="12" v-if="enableTwoFactor">
                      <b-row>
                        <b-col md="12">
                          <div
                            class="flex align-items-center justify-content-between"
                          >
                            <h4>Biometric verification</h4>
                            <c-switch
                              class="mx-1"
                              color="primary"
                              v-model="enableTwoFactorBio"
                              label
                              variant="pill"
                              data-on="|"
                              data-off="|"
                            />
                          </div>
                        </b-col>
                        <b-col md="12">
                          <b-row class="mt-2">
                            <b-col md="4">
                              <h5>Select Verification Methods</h5></b-col
                            >
                            <b-col>
                              <eb-select
                                type="select"
                                :options="verificationOptions"
                                label="label"
                                id="docs"
                                placeholder="Select Verification Methods"
                                class="mt-0 currencyNameDropdown mb-0"
                                v-model="selectedVerificationType"
                                :selected="selectedVerificationType"
                                @input="onSelectVerificationType"
                              ></eb-select>
                            </b-col>
                            <b-col md="1" class="text-center"
                              ><img
                                src="@/assets/images/add_icon.png"
                                @click="addDocConfig"
                                alt
                                style="cursor: pointer; width: 90%"
                            /></b-col>
                          </b-row>
                          <b-row> </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import profile from "@/components/profile/profileCategory";
import ebSelect from "@/components/FormElements/Select.vue";
import { Switch as cSwitch } from "@coreui/vue";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  components: {
    profile,
    cSwitch,
    ebSelect,
    ComponentHeader,
  },
  data() {
    return {
      tabIndex: 0,
      allTypes: ["Partners", "Customers", "Agents"],
      otpBased: false,
      passwordBased: false,
      enableTwoFactor: false,
      enableTwoFactorOtp: false,
      enableTwoFactorBio: false,
      otpSendThrough: "",
      loginStyle: "",
      verificationOptions: [
        { label: "Face Scan", value: "faceScan" },
        { label: "Image Upload", value: "imageUpload" },
      ],
      selectedVerificationType: "",
    };
  },
  methods: {
    changeOtpSendThrough(val) {
      this.otpSendThrough = val;
    },
    changeLoginStyle(val) {
      this.loginStyle = val;
    },
    onSelectVerificationType() {
      //
    },
    addDocConfig() {
      //
    },
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>

<style scoped>
.small-text {
  font-weight: 500 !important;
  font-size: 15px;
  margin-top: -4px;
  color: #000;
  margin-bottom: 5px;
}
::v-deep .switch-primary .switch-input:checked + .switch-slider {
  background-color: #34a853;
  border-color: #34a853;
}
.password-based {
  background-color: #fbfaff;
  margin: 0px 1px;
  border-radius: 5px;
  padding: 12px;
}
.factor {
  border-radius: 5px;
  border: 1px solid #dee3ea;
  background: #fff;
  padding: 8px;
}
.factor h4 {
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>
